import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const clientErrorsApi = createApi({
  reducerPath: 'clientErrorsApi',
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    reportClientError: builder.mutation({
      query: (error) => ({
        url: urls.clientErrors,
        method: 'POST',
        data: error,
        // diagnostics only: no error page, toast or global fetching state
        silent: true,
      }),
    }),
  }),
});

export const { useReportClientErrorMutation } = clientErrorsApi;
